export const PerfilGestaoSped = {
  AdminProduto: 1,
  Consulta: 6,
};

export const PerfisReadOnly: ReadonlyArray<number> = [
  PerfilGestaoSped.AdminProduto,
  PerfilGestaoSped.Consulta,
];
